// Contenu de la plaquette — Page / section "Mon approche"
// Sections E, F, G

export const approachIntro = {
  heading: "Mes deux approches complémentaires",
  items: [
    "01 — La psychothérapie intégrative : Profondeur-exploration",
    "02 — Les thérapies brèves : Focus et action",
  ],
  image: {
    src: "/seance-therapie.jpg",
    alt: "Séance de psychothérapie, prise de notes",
  },
};

// Section F
export const integrativeTherapy = {
  number: "01",
  heading: "La psychothérapie intégrative : Profondeur-exploration",
  intro:
    "Proche de la psychothérapie traditionnelle largement connue, elle ne se limite cependant pas à une seule approche (clinique, socio-cognitive, systémique, neuropsychologique…) mais combine différents outils pour travailler sur les émotions, les pensées, les comportements et les relations. Elle prend sens dans la relation de confiance et le déroulement narratif et comporte une dimension exploratoire de soi.",
  objectivesHeading: "L'objectif est de :",
  objectives: [
    "Mettre du sens sur ses émotions, ses pensées et son histoire, afin de mieux se comprendre et de retrouver une cohérence intérieure ;",
    "Reconnaître et valider la complexité de nos vécus, ainsi que nos forces et notre résilience face aux défis rencontrés ;",
    "Comprendre comment les rapports de pouvoir (racisme, sexisme, classisme, homophobie, validisme, etc.) interagissent dans notre vie et notre vision de nous-même ;",
    "Reprendre confiance en soi.",
  ],
  quote:
    "Déplions nos émotions et apprenons à leur donner des mots, pour vivre avec elles plutôt que contre elles. Il est temps de réajuster nos lunettes sur notre réalité, et non sur celle des autres, afin de poser un regard bienveillant sur nous-mêmes.",
};

// Section G
export const briefTherapy = {
  number: "02",
  heading: "Les thérapies brèves : Focus et action",
  intro:
    "Si la psychothérapie intégrative vous permet d'explorer en profondeur votre histoire et vos émotions, les thérapies brèves se concentrent sur un objectif précis à court ou moyen terme, sur un nombre limité de séances. En d'autres mots, elles se concentrent sur des solutions concrètes plutôt que sur l'exploration exhaustive de votre histoire, afin de mettre en lumière ce qui vous bloque et révéler vos forces et vos ressources pour avancer avec confiance.",
  paragraph2:
    "Je m'appuie sur des techniques variées provenant de différentes approches (TCC, PNL, systémique…), ainsi que sur des outils thérapeutiques inclusifs, pour vous aider à repérer vos schémas problématiques et à mettre en place des stratégies personnalisées, efficaces et durables.",
  warning:
    "La thérapie brève est tentante mais n'est pas une baguette magique : elle n'aide à avancer que lorsqu'un travail intérieur profond et solide a déjà été engagé au préalable par une psychothérapie intégrative. Autrement, le travail risque de rester superficiel, de masquer les émotions profondes et de donner l'illusion d'un changement rapide sans transformation réelle.",
  quote:
    "Aller mieux n'est pas une course ni une obligation ! La dignité humaine exige de se donner du temps, de la lenteur, du respect et de la douceur bienveillante. Ne tombons pas dans les pièges du jugement, de la pression performative ou de la culpabilité, qui nous font devenir les bourreaux de notre propre quête de bien-être. Prenons le temps de grandir et pas de nous punir !",
};
